// import Dashboard from "views/Dashboard/Dashboard";
// import UserProfile from "views/UserProfile/UserProfile";
// import TableList from "views/TableList/TableList";
// import Typography from "views/Typography/Typography";
// import Icons from "views/Icons/Icons";
// import Maps from "views/Maps/Maps";
// import Notifications from "views/Notifications/Notifications";
// import Upgrade from "views/Upgrade/Upgrade";

const adminRoutes = [
  { path: '/AdminStatistic',    name: 'Admin panel' },
  { redirect: true, path: '/AdminStatistic', to: '/AdminStatistic', name: 'Login'},
  { redirect: true, path: '/', to: '/login', name: 'Login' }
];

export default adminRoutes;
